import React from 'react';
import './MainScreen.css';

class Searchbar extends React.Component {
	handleChange = (event) => {
		this.setState({
			term: event.target.value
		});

	};
	handleSubmit = event => {
		event.preventDefault();
		this.props.handleFormSubmit(this.state.term);
	}

	render() {

		return (
			<div className='center margin'>
				<h2><img style={{width:'50px', height:'25px'}} src='https://www.thatitguy.net/wp-content/uploads/2018/08/1280px-Logo_of_YouTube_2015-2017.svg.png' alt="youtube logo"></img></h2>
				<div className='search-bar ui segment'>
					<form onSubmit={this.handleSubmit} className='ui form'>
						<div className='field'>

							<label className='label' htmlFor="video-search">Wyszukaj utwór</label>

							<input className='inputYT' onChange={this.handleChange} name='video-search'
								type="text" placeholder="Szukaj"/>

							<button className='submitBtn'>WYSZUKAJ</button>

						</div>
					</form>
				</div>
			</div>
		)
	}
}
export default Searchbar;